import { useSelector } from "react-redux";
import { IframeFAB } from "@/react/features/globalization/IframeFAB";
import PageLayout from "@/react/features/styled/PageLayout";

export function OpenInTapFAB(props) {
  const isIframe = useSelector((state) => state.application.isIframe);
  return (
    <>
      {isIframe && <IframeFAB />}
      <PageLayout>{props.children}</PageLayout>
    </>
  );
}
